import React, { useEffect, useState } from 'react';
import API_CONFIG from '../config/api.config';

interface BackendVersionInfo {
  imageTag: string;
  aiEngineVersion: string;
}

const VersionTracker: React.FC = () => {
  const buildDate = import.meta.env.VITE_BUILD_DATE || new Date().toISOString().split('T')[0];
  const commitHash = import.meta.env.VITE_COMMIT_HASH || 'dev';

  const [backendVersion, setBackendVersion] = useState<BackendVersionInfo | null>(null);

  useEffect(() => {
    const fetchBackendVersion = async () => {
      try {
        const response = await fetch(`${API_CONFIG.apiUrl}/version`);
        if (response.ok) {
          const data = await response.json();
          setBackendVersion({
            imageTag: data.imageTag || 'unknown',
            aiEngineVersion: data.aiEngineVersion || 'unknown',
          });
        }
      } catch {
        // Backend not reachable
      }
    };
    fetchBackendVersion();
  }, []);

  return (
    <div className="text-xs text-tertiary flex items-center gap-2 flex-wrap">
      <span title={`Frontend: ${commitHash}`} className="font-mono">
        {commitHash.substring(0, 7)}
      </span>
      {backendVersion && (
        <>
          <span className="text-tertiary/50">•</span>
          <span title="Backend API Version">Backend: {backendVersion.imageTag}</span>
          <span className="text-tertiary/50">•</span>
          <span title="AI Engine Version">AI: {backendVersion.aiEngineVersion}</span>
        </>
      )}
      <span className="text-tertiary/50 hidden sm:inline">•</span>
      <span className="hidden sm:inline">{buildDate}</span>
    </div>
  );
};

export default VersionTracker;
